import { render, staticRenderFns } from "./NotizModal.vue?vue&type=template&id=0c0a7756&scoped=true"
import script from "./NotizModal.vue?vue&type=script&lang=js"
export * from "./NotizModal.vue?vue&type=script&lang=js"
import style0 from "./NotizModal.vue?vue&type=style&index=0&id=0c0a7756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a7756",
  null
  
)

export default component.exports